import { render, staticRenderFns } from "./VipBenefit.vue?vue&type=template&id=24c9bc14&"
import script from "./VipBenefit.vue?vue&type=script&lang=ts&"
export * from "./VipBenefit.vue?vue&type=script&lang=ts&"
import style0 from "./VipBenefit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports